
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/copiercosts/privacy-policy",
      function () {
        return require("private-next-pages/copiercosts/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/copiercosts/privacy-policy"])
      });
    }
  